export default __webpack_public_path__ + "static/media/DisabledAddIcon.401b6577.svg";